import queries from '@apis/queries';
import { GetInquiriesParams, InquiryRow } from '@models/inquiry';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

function useInquiries() {
  const [page, setPage] = useState<number>(0);
  const params: GetInquiriesParams = {
    page, size: 10,
  };
  const [inquiries, setInquiries] = useState<InquiryRow[]>([]);
  const { data, status } = useQuery(queries.inquiry.list(params));
  useEffect(() => {
    if (data) {
      if (data.slice.first) {
        setInquiries(data.content);
      } else {
        setInquiries((prev) => [...prev, ...data.content]);
      }
    }
  }, [data]);
  const fetchNext = () => {
    if (status === 'success' && !data?.slice.last) {
      setPage((prev) => prev + 1);
    }
  };
  return {
    inquiries, fetchNext,
  };
}

export default useInquiries;
